import React from "react";
import PropTypes from "prop-types";
import { generateReactKey } from "../../utils/reactKey";
import FormOverviewSection from "../form-overview-section";

export default function AccountOverviewForm({ formSections = [] }) {
  return (
    <div className="account-overview-form">
      {formSections.map((item, index) => (
        <FormOverviewSection key={index} heading={item.heading} items={item.items} button={item.button} />
      ))}
    </div>
  );
}

AccountOverviewForm.propTypes = {
  formSections: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.shape({
        type: PropTypes.object,
        html: PropTypes.object,
        typographyClass: PropTypes.string
      }),
      items: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string
        })
      ),
      button: PropTypes.object
    })
  ).isRequired
};
